import React from 'react';
import { Col, Row } from 'react-bootstrap';

const TrainingVideo = ({ data }: any) => {
  return (
    <div className="TrainingVideo-background">
      <div className="container">
        <h2 className="TrainingVideo-title">{data.groupTitle}</h2>
        <Row md={3} xs={1}>
          {data.VideoPlayerCardWidget.map((item: any, i: any) => {
            return (
              <Col key={i}>
                <iframe className="TrainingVideo-videoframe" src={item.url} title={i} allowFullScreen />
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default TrainingVideo;
